module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Usb-storage-0db2902480f2e80514b6f25da0f1b7e4.svg";